import { render, staticRenderFns } from "./baseSearchDetails.vue?vue&type=template&id=3c8e7774&scoped=true&"
import script from "./baseSearchDetails.vue?vue&type=script&lang=js&"
export * from "./baseSearchDetails.vue?vue&type=script&lang=js&"
import style0 from "./baseSearchDetails.vue?vue&type=style&index=0&id=3c8e7774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e7774",
  null
  
)

export default component.exports